import {
  GET_DETAILS_DATA,
  SET_DETAILS_LOADING,
  GET_DETAILS_MULTIPLE_DATA,
  UPDATE_DETAILS_DATA,
  ADD_DETAILS_DATA,
  DELETE_DETAILS_DATA,
  ADD_DISCOUNT,
  UPDATE_DISCOUNT,
  DELETE_DISCOUNT,
  ADD_VOLUME_CONTRACT,
  UPDATE_VOLUME_CONTRACT,
  DELETE_VOLUME_CONTRACT,
  GET_DOCUMENTS_BEFORE_SIGNING,
  GET_DOCUMENTS_AFTER_SIGNING,
  GET_DOCUMENT_TYPE_BEFORE_SIGNING,
  GET_DOCUMENT_TYPE_AFTER_SIGNING,
  GET_CONTACT_DOCUMENT_NOTES,
  CREATE_CONTACT_DOCUMENT_NOTE,
  DELETE_CONTACT_DOCUMENT_NOTE,
} from './types'

const initialState = {
  data: {},
  multipleData: [],
  documentsBeforeSigning: [],
  documentsAfterSigning: [],
  documentsTypeBeforeSigning: [],
  documentsTypeAfterSigning: [],
  notes: [],
  isLoading: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_DOCUMENT_TYPE_BEFORE_SIGNING:
      return {
        ...state,
        documentsTypeBeforeSigning: action.payload,
      }
    case GET_DOCUMENT_TYPE_AFTER_SIGNING:
      return {
        ...state,
        documentsTypeAfterSigning: action.payload,
      }
    case GET_DOCUMENTS_BEFORE_SIGNING:
      return {
        ...state,
        documentsBeforeSigning: action.payload,
        isLoading: false,
      }
    case GET_DOCUMENTS_AFTER_SIGNING:
      return {
        ...state,
        documentsAfterSigning: action.payload,
        isLoading: false,
      }
    case ADD_VOLUME_CONTRACT:
      return {
        ...state,
        multipleData: state.multipleData.map((data) => {
          if (data.id === action.searchField) {
            data.volumeContracts
              ? data.volumeContracts.push(action.payload)
              : (data.volumeContracts = [{ ...action.payload }])
            return data
          }
          return data
        }),
      }
    case UPDATE_VOLUME_CONTRACT:
      return {
        ...state,
        multipleData: state.multipleData.map((data) => {
          data.volumeContracts = data.volumeContracts.map((volumeContractItem) => {
            if (volumeContractItem.id === action.payload.id) {
              volumeContractItem = action.payload
              return volumeContractItem
            } else {
              return volumeContractItem
            }
          })
          return data
        }),
      }
    case DELETE_VOLUME_CONTRACT:
      return {
        ...state,
        multipleData: state.multipleData.map((data) => {
          data.volumeContracts = data.volumeContracts.filter(
            (volumeContractItem) => volumeContractItem.id !== action.payload
          )
          return data
        }),
      }
    case ADD_DISCOUNT:
      return {
        ...state,
        multipleData: state.multipleData.map((data) => {
          if (data.id === action.payload.competitionId) {
            if (data.discounts) {
              data.discounts.push(action.payload)
            } else {
              data.discounts = [{ ...action.payload }]
            }
            return data
          } else {
            return data
          }
        }),
      }
    case DELETE_DISCOUNT:
      return {
        ...state,
        multipleData: state.multipleData.map((data) => {
          data.discounts = data.discounts.filter((discount) => discount.id !== action.payload)
          return data
        }),
      }
    case UPDATE_DISCOUNT:
      return {
        ...state,
        multipleData: state.multipleData.map((data) => {
          data.discounts = data.discounts.map((discount) => {
            if (discount.id === action.payload.id) {
              discount = action.payload
              return discount
            } else {
              return discount
            }
          })
          return data
        }),
      }
    case GET_DETAILS_DATA:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      }
    case GET_DETAILS_MULTIPLE_DATA:
      return {
        ...state,
        multipleData: action.payload,
        isLoading: false,
      }
    case UPDATE_DETAILS_DATA: {
      return {
        ...state,
        multipleData: state.multipleData.map((data) => {
          if (data.id === action.payload.id) {
            return action.payload
          } else {
            return data
          }
        }),
        isLoading: false,
      }
    }
    case ADD_DETAILS_DATA: {
      return {
        ...state,
        multipleData: [...state.multipleData, ...action.payload],
        isLoading: false,
      }
    }
    case DELETE_DETAILS_DATA: {
      return {
        ...state,
        multipleData: state.multipleData.filter((data) => {
          return data.id !== action.payload
        }),
        isLoading: false,
      }
    }
    case SET_DETAILS_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case GET_CONTACT_DOCUMENT_NOTES:
      return {
        ...state,
        isLoading: false,
        notes: action.payload,
      }

    case CREATE_CONTACT_DOCUMENT_NOTE:
      return {
        ...state,
        notes: [action.payload, ...state.notes],
        isLoading: false,
      }
    case DELETE_CONTACT_DOCUMENT_NOTE:
      return {
        ...state,
        notes: state.notes.filter((note) => note.id !== action.payload),
        isLoading: false,
      }
    default:
      return state
  }
}
